import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/health/followupplan/list',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/followupplan/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/followupplan/submit',
    method: 'post',
    data: row
  })
}

export const getSubmit = (row) => {
  return request({
    url: '/health/followupplan/submit',
    method: 'post',
    data: row
  })
}

export const getDetail = (wxUserId) => {
  return request({
    url: '/health/followupplan/detail',
    method: 'get',
    params: {
      wxUserId
    }
  })
}

